import { jsx as _jsx } from "react/jsx-runtime";
import { useStores } from "../../../../store/root.js";
const PermissionCheck = ({ children, minRole })=>{
    const { rcbAuthenticationStore } = useStores();
    const isNotAllowed = !rcbAuthenticationStore.hasRole(minRole);
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "initial"
        },
        hidden: isNotAllowed,
        children: children
    });
};
export { PermissionCheck };
